// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICheckReissueDto
 */
export interface ICheckReissueDto {
    /**
     * 
     * @type {number}
     * @memberof ICheckReissueDto
     */
    payment_method_id?: number;
}

/**
 * Check if a given object implements the ICheckReissueDto interface.
 */
export function instanceOfICheckReissueDto(value: object): value is ICheckReissueDto {
    return true;
}

export function ICheckReissueDtoFromJSON(json: any): ICheckReissueDto {
    return ICheckReissueDtoFromJSONTyped(json, false);
}

export function ICheckReissueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICheckReissueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
    };
}

export function ICheckReissueDtoToJSON(json: any): ICheckReissueDto {
    return ICheckReissueDtoToJSONTyped(json, false);
}

export function ICheckReissueDtoToJSONTyped(value?: ICheckReissueDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_id': value['payment_method_id'],
    };
}

